const SECTIONS = [
  {
    title: "Privacy Policy",
    body: [
      "Customize Gift Online collects only the information needed to fulfil your order: your name, contact details, delivery address, and the photos/text you choose for personalization.",
      "Your uploaded photos are used solely to create your personalized gift and are never shared, sold or used for marketing.",
      "Payment details are processed by our payment partner over encrypted connections; we never store card numbers.",
      "You can request deletion of your account and associated data anytime by writing to customizegiftonline@gmail.com.",
      "(Editable placeholder — replace with your finalized legal policy before going live.)",
    ],
  },
  {
    title: "Terms & Conditions",
    body: [
      "By placing an order you confirm that the photos and text you upload belong to you or that you have permission to use them.",
      "We may refuse to print content that is unlawful, offensive or infringes on others' rights; such orders are cancelled and refunded.",
      "Estimated delivery dates are shared in good faith and can shift during peak seasons or due to courier delays — we'll always keep you posted.",
      "Prices, coupons and offers can change without notice; the amount confirmed at checkout is final for that order.",
      "(Editable placeholder — replace with your finalized legal terms before going live.)",
    ],
  },
];

export default function PoliciesPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12 lg:py-16" data-testid="policies-page">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#B45309]">Policies</p>
      <h1 className="font-serif text-3xl sm:text-4xl font-bold text-stone-900 mt-3 tracking-tight">Privacy & Terms</h1>
      <div className="mt-10 space-y-8">
        {SECTIONS.map((s) => (
          <section key={s.title} className="p-6 sm:p-8 rounded-2xl bg-white border border-[#E9E2D7]" data-testid={`policy-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <h2 className="font-serif text-2xl font-bold text-stone-900">{s.title}</h2>
            <div className="mt-4 space-y-3">
              {s.body.map((p, i) => (
                <p key={i} className="text-sm text-stone-600 leading-relaxed">{p}</p>
              ))}
            </div>
          </section>
        ))}
      </div>
      <p className="text-sm text-stone-500 mt-8 text-center">Questions about these policies? Write to <a href="mailto:customizegiftonline@gmail.com" className="font-bold text-[#B45309] hover:underline">customizegiftonline@gmail.com</a></p>
    </div>
  );
}
